const APPLY_URL = "https://pro.form-mailer.jp/fms/e40aa43b232020";

export default function HeroSection() {
  const scrollToPricing = () => {
    const el = document.getElementById("pricing");
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* Background image */}
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/fdd47dc704abb784f5b8f076d838c250.jpg"
          alt="義歯の笑顔"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-black/70 via-black/50 to-black/30" />
      </div>

      {/* Content */}
      <div className="relative z-10 w-full max-w-6xl mx-auto px-6 py-32 flex flex-col items-center text-center">

        <div className="inline-flex items-center gap-2 bg-amber-500/90 text-white text-xs font-semibold px-4 py-1.5 rounded-full mb-6 tracking-wider">
          <span>入れ歯専門クリニック</span>
          <span>|</span>
          <span>札幌</span>
        </div>

        <h1 className="text-4xl md:text-6xl font-bold text-white leading-tight mb-6" style={{ fontFamily: "'Noto Serif JP', serif" }}>
          入れ歯を紛失・破損した方へ<br />
          <span className="text-amber-400">たった1回の通院</span>で<br />
          入れ歯が完成します
        </h1>

        <p className="text-white/80 text-lg md:text-xl max-w-xl mb-10 leading-relaxed">
          朝9時に治療を開始し、夕方には新しい入れ歯をお渡し。<br />
          入れ歯の種別に関わらず<strong className="text-amber-300">1床33万円（税込）</strong>の明瞭会計。
        </p>

        <div className="flex flex-col sm:flex-row gap-4">
          <a
            href={APPLY_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="whitespace-nowrap cursor-pointer bg-amber-500 hover:bg-amber-600 text-white font-bold text-base px-8 py-4 rounded-md transition-colors"
          >
            今すぐ申し込む
          </a>
          <button
            onClick={scrollToPricing}
            className="whitespace-nowrap cursor-pointer bg-white/20 hover:bg-white/30 border border-white/60 text-white font-semibold text-base px-8 py-4 rounded-md transition-colors backdrop-blur-sm"
          >
            料金を確認する
          </button>
        </div>

        {/* Scroll indicator */}
        <div className="absolute bottom-10 left-1/2 -translate-x-1/2 flex flex-col items-center gap-2 text-white/50 animate-bounce">
          <span className="text-xs tracking-widest">SCROLL</span>
          <i className="ri-arrow-down-line text-lg" />
        </div>
      </div>
    </section>
  );
}
